import { render } from "./ContactsModal.vue?vue&type=template&id=359f0822&scoped=true"
import script from "./ContactsModal.vue?vue&type=script&lang=js"
export * from "./ContactsModal.vue?vue&type=script&lang=js"

import "./ContactsModal.vue?vue&type=style&index=0&id=359f0822&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359f0822"]])

export default __exports__